import React, { useState } from "react";
import {
  ActionButton,
} from "./DeleteButton.styles";
import DeleteIcon from "@mui/icons-material/Delete";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

const DeleteButton = ({ tender, onDelete }) => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => !loading && setOpen(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onDelete(tender.tender_id);
      setOpen(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ActionButton
        data-testid="delete-button"
        onClick={handleClickOpen}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress size={24} />
        ) : (
          <DeleteIcon />
        )}
      </ActionButton>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Delete this tender?</DialogTitle>
        <DialogActions>
          <Button
            onClick={handleClose}
            disabled={loading}
            sx={{ color: 'black' }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirm}
            color="error"
            disabled={loading}
            data-testid="confirm-delete"
          >
            {loading ? <CircularProgress size={20} /> : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteButton;